import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { RateTemplateService } from "@root/router/rate/rate-template/rate-template.service";
import _ from "lodash";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
  selector: "host-rate-tpl-picker",
  templateUrl: "./rate-tpl-picker.component.html",
  styleUrls: ["./rate-tpl-picker.component.scss"],
})
export class RateTplPickerComponent implements OnInit {
  // @Input() initialValue = null;
  @Input() size: "small" | "large" | "default" = "default";
  @Output() onSelect = new EventEmitter<any>();
  listOfTemplate = [];
  listOfGroup = [];
  visible = false;
  currentGroupId = -1;
  value = null;
  constructor(
    private tplService: RateTemplateService,
    private modalService: NzModalService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.fetchGroupList();
    this.fetchTemplateList();
  }

  fetchTemplateList() {
    const params = {};

    if (this.currentGroupId !== -1) {
      Object.assign(params, { quick_comment_group_ids: JSON.stringify([this.currentGroupId]) });
    }

    this.tplService.fetchRateList(params).subscribe((res) => {
      this.listOfTemplate = _.get(res, "data.list") || [];
    });
  }

  fetchGroupList() {
    this.tplService.fetchGroupList().subscribe((res) => {
      this.listOfGroup = _.get(res, "data.list") || [];
    });
  }

  onClickGroup(id) {
    this.currentGroupId = id;

    this.fetchTemplateList();
  }

  onClickItem(tpl) {
    this.listOfTemplate.forEach((item) => (item.select = false));
    tpl.select = !tpl.select;
    // this.listOfTemplate = this.listOfTemplate.map(item => ({ ...item, select: false }));
    // tpl.select = true;
    this.confirm();
    console.log("this.listOfTemplate: ", this.listOfTemplate);
  }

  confirm() {
    const tpl = this.listOfTemplate.find((item) => item.select);
    if (!tpl) {
      return this.cancel();
    } else {
      this.emit(tpl);
      this.closePanel();
    }
  }

  cancel() {
    this.closePanel();
  }

  reset() {
    this.emit(null);
    this.closePanel();
  }

  toTemplatePage() {
    this.modalService.closeAll();
    this.router.navigate(["/app/reviews/template"]);
  }

  private emit(template) {
    this.value = template;
    this.onSelect.emit(template ? template : null);
  }

  private closePanel() {
    this.visible = false;
  }
}
